import React, { useContext, useState } from "react";
import { useAuth } from "../../../../context/AuthContext";
import Checkbox from "../../../molecules/formComponents/checkbox/Checkbox";
import UnfilledButton from "../../../molecules/buttons/unfilledButton/UnfilledButton";
import AppContext from "../../../../context/AppContext";
import FilledButton from "../../../molecules/buttons/filledButton/FilledButton";
import { askForOldEstimationsTransfertApi } from "../../../../api/UtilsApi";

function V1AccessForm() {
  const [checkboxValue, setCheckboxValue] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const { getUuid, refreshUserData } = useAuth();
  const { setModalVisible, createNotification } = useContext(AppContext);

  async function handleSubmit(checkboxValue) {
    setIsButtonLoading(true);
    try {
      if (checkboxValue) await askForOldEstimationsTransfertApi(getUuid());
      refreshUserData();
      window.open(`${process.env.REACT_APP_V1_URL}/tableau-de-bord`);
    } catch (error) {
      createNotification(
        <>Une erreur est survenue lors de la demande de transfert. Veuillez réessayer.</>,
        "var(--red)",
        "var(--dark-blue)",
      );
    } finally {
      setIsButtonLoading(false);
      setModalVisible(false);
    }
  }

  return (
    <>
      <p className='mb-md'>
        Avant de migrer vos anciennes estimations vers votre nouvel espace, nous aimerions savoir si vous souhaitez les
        conserver.
        <br />
        Nous profitons de cette transition pour simplifier et optimiser la gestion de nos données, afin de réduire notre
        impact écologique.
      </p>
      <ul className='dots-list'>
        <li>
          Si vous ne souhaitez pas conserver vos anciennes estimations, sachez qu’elles resteront disponibles jusqu’au
          30 juin.
        </li>
        <li>
          Si vous souhaitez les récupérer, il vous suffit de cocher la case ci-dessous : vos estimations seront alors
          transférées très prochainement.
        </li>
      </ul>
      <Checkbox
        checked={checkboxValue}
        onClick={() => setCheckboxValue(value => !value)}
        label='Je fais une demande de transfert pour mes anciennes estimations'
      />
      <div className='modal-buttons-row'>
        <UnfilledButton padding='10px 20px' onClick={() => setModalVisible(false)}>
          Annuler
        </UnfilledButton>
        <FilledButton isLoading={isButtonLoading} padding='10px 20px' onClick={() => handleSubmit(checkboxValue)}>
          Accéder à mes anciennes estimations
        </FilledButton>
      </div>
    </>
  );
}

export default V1AccessForm;
